import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'ramda';

import { bonusesRestHooks } from '../../../../../../store/Memberships/BonusesSlice';
import { bonusRestHooks } from '../../../../../../store/Memberships/BonusSlice';
import BonusPresenter from '../../../../../../presenters/Membership/BonusPresenter';
import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import ListSkeleton from '../../../../../../components/Skeletons/ListSkeleton';
import {
  LIST_SKELETON_HEIGHT,
  LIST_SKELETON_WIDTH,
} from '../../../../../../pages/constants';
import { Dialog } from '../../../../../../components';

import BonusesTable from './components/BonusesTable';

const Bonuses = (props) => {
  const { membershipId, onResponseUpdate } = props;
  const {
    loadBonuses,
    loadResetBonuses,
    bonuses: { loadingStatus, items },
  } = bonusesRestHooks.use();

  const {
    createBonus,
    deleteBonus,
    bonus: { errors },
  } = bonusRestHooks.use();

  const { isFulfilled } = useFetchStatus(loadingStatus);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [deletedBonus, setDeletedBonus] = useState(null);
  const handleDialogOpen = (bonus) => () => {
    setDeletedBonus(bonus);
    setIsDialogOpen(true);
  };
  const handleDialogClose = () => setIsDialogOpen(false);
  const bonusType = BonusPresenter.typeReadable(deletedBonus);
  const bonusAmount = BonusPresenter.amountReadable(deletedBonus);
  const warningText = `Are you sure you want to remove ${bonusType} bonus with ${bonusAmount} amount?`;

  const handleDeleteConfirm = async () => {
    const membershipId = BonusPresenter.membershipId(deletedBonus);
    const bonusId = BonusPresenter.id(deletedBonus);
    await deleteBonus(membershipId, bonusId);

    handleDialogClose();
    loadBonuses(membershipId);
  };

  const handleBonusCreate = async (...params) => {
    await createBonus(...params);

    loadBonuses(membershipId);
  };

  useEffect(() => {
    loadBonuses(membershipId);
    return () => {
      loadResetBonuses();
    };
  }, []);

  useEffect(() => {
    if (!isNil(errors)) {
      onResponseUpdate({ body: errors });
    }
    return () => {
      onResponseUpdate({});
    };
  }, [errors]);

  if (!isFulfilled) {
    return (
      <ListSkeleton height={LIST_SKELETON_HEIGHT} width={LIST_SKELETON_WIDTH} />
    );
  }

  return (
    <div>
      <Dialog
        className="deletion"
        isOpen={isDialogOpen}
        message={warningText}
        onConfirm={handleDeleteConfirm}
        onCancel={handleDialogClose}
      />
      <BonusesTable
        bonuses={items}
        membershipId={membershipId}
        onDialogOpen={handleDialogOpen}
        onBonusCreate={handleBonusCreate}
      />
    </div>
  );
};

export default Bonuses;

Bonuses.propTypes = {
  membershipId: PropTypes.string.isRequired,
  onResponseUpdate: PropTypes.func.isRequired,
};
